<div>
  <app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>
  <form #ta="ngForm" class="formborder">
    <div class="col-md-12 row my-2" style="display: flex; align-items: center">
      <div class="col-md-2">
        <label class="required-lable" for="DueFromDate">DueDate From</label>

        <div class="datepicker_feild">
          <input
            [matDatepicker]="picker1"
            dateConvert
            placeholder="DD/MM/YYYY"
            name="DueFromDate"
            id="DueFromDate"
            required
            #ref_due_from="ngModel"
            class="form-control input-text-css"
            [(ngModel)]="DueFromDate"
            [ngClass]="{
              'is-invalid': ta.submitted && ref_due_from.invalid,
              'alert-warning':
                ref_due_from.invalid &&
                (ref_due_from.dirty ||
                  ref_due_from.touched ||
                  ref_due_from.untouched)
            }"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker1"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </div>
      </div>
      <div class="col-md-2">
        <label class="required-lable" for="DateTo">DueDate To</label>
        <div class="datepicker_feild">
          <input
            [matDatepicker]="picker2"
            dateConvert
            placeholder="DD/MM/YYYY"
            name="DueToDate"
            id="DueToDate"
            required
            [min] = "DueFromDate"
            #ref_due_to="ngModel"
            class="form-control input-text-css"
            [(ngModel)]="DueToDate"
            [ngClass]="{
              'is-invalid': ta.submitted && ref_due_to.invalid,
              'alert-warning':
                ref_due_to.invalid &&
                (ref_due_to.dirty ||
                  ref_due_to.touched ||
                  ref_due_to.untouched)
            }"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker2"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </div>
        </div>
         <div class="col-md-2">
        <label class = "required-lable" for="ReceiveFrom">ReceiveDate From</label>

        <div class="datepicker_feild">
          <input
            [matDatepicker]="picker3"
            dateConvert
            placeholder="DD/MM/YYYY"
            name="ReceiveFrom"
            id="ReceiveFrom"
            required
            [min] = "DueFromDate"
            #ref_receive_from="ngModel"
            class="form-control input-text-css"
            [(ngModel)]="ReceiveFrom"
            [ngClass]="{
              'is-invalid': ta.submitted && ref_receive_from.invalid,
              'alert-warning':
                ref_receive_from.invalid &&
                (ref_receive_from.dirty ||
                  ref_receive_from.touched ||
                  ref_receive_from.untouched)
            }"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker3"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker3></mat-datepicker>
        </div>
      </div>
      <div class="col-md-2">
        <label class="required-lable" for="ReceiveTo">ReceiveDate To</label>
        <div class="datepicker_feild">
          <input
            [matDatepicker]="picker4"
            dateConvert
            placeholder="DD/MM/YYYY"
            name="ReceiveTo"
            id="ReceiveTo"
            required
            #ref_receive_to="ngModel"
            class="form-control input-text-css"
            [(ngModel)]="ReceiveTo"
            [ngClass]="{
              'is-invalid': ta.submitted && ref_receive_to.invalid,
              'alert-warning':
                ref_receive_to.invalid &&
                (ref_receive_to.dirty ||
                  ref_receive_to.touched ||
                  ref_receive_to.untouched)
            }"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker4"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker4></mat-datepicker>
        </div>
      </div>
<!-- OP MODEL -->
    <div class="col-md-2">
      <label>Branch</label>
      <app-multi-select-dropdown
      placeholder="Select Branch"
      [data]="BranchesList"
      [settings]="branchSettings"
      (selectionChange)="onBranchSelectionChange($event)"
    ></app-multi-select-dropdown>
    </div>

    <div class="col-md-2">
      <label>Product</label>
      <app-multi-select-dropdown
      placeholder="Select Product"
      [data]="ProductList"
      [settings]="productSettings"
      (selectionChange)="onProductSelectionChange($event)"
    ></app-multi-select-dropdown>
    </div>
    <!-- OP MODEL -->
     <div class="col-md-2">
        <div>&nbsp;</div>
        <button
          class="mt-2 btn font-size-12 button-btn"
          (click)="onsearchemidetails()"
          [disabled]="ta.form.invalid"
        >
          Search
        </button>
      </div>
      <div class="col-md-4 mt-3">
        <form action="" class="search-text">
          <div class="bg-light rounded rounded-pill shadow-sm">
            <div class="input-group">
              <input
                type="text"
                id="FilterInputSearch"
                (keyup)="applyFilter($event.target.value)"
                name="FilterInputSearch"
                placeholder="What're you searching for?"
                class="form-control border-0 bg-light"
              />
              <div class="input-group-append">
                <button
                  id="button-addon1"
                  type="submit"
                  class="btn btn-link text-primary"
                >
                  <i class="fa fa-search"></i>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </form>


<div class="row mt-3"   [hidden]="!DataSource">
  <div class="col-md-12" >
    <div class="table-responsive" >
      <mat-table 
        class="table-bordered table-striped"
        matSort
        [dataSource]="DataSource"
        matTableExporter
        #exporter="matTableExporter"
        style="overflow: auto; height: fit-content; max-width: 100%"
      >
        <ng-container matColumnDef="#">
          <mat-header-cell mat-sort-header *matHeaderCellDef>#</mat-header-cell>
          <mat-cell *matCellDef="let row; let i = index">
            {{ paginatorRef.pageIndex * paginatorRef.pageSize + (i + 1) }}
          </mat-cell>
          <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="Application_No">
          <mat-header-cell mat-sort-header *matHeaderCellDef
            >Application No</mat-header-cell
          >
          <mat-cell *matCellDef="let row">{{ row.Application_No }}</mat-cell>
          <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container> 

        <ng-container matColumnDef="LoanAcNo">
          <mat-header-cell mat-sort-header *matHeaderCellDef
            >LoanAcNo</mat-header-cell
          >
          <mat-cell *matCellDef="let row">
            {{ row.LoanAcNo }}
          </mat-cell>
          <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="Customer_Name">
          <mat-header-cell mat-sort-header *matHeaderCellDef
            >Customer Name</mat-header-cell
          >
          <mat-cell *matCellDef="let row">
            {{ row.Customer_Name }}
          </mat-cell>
          <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="Customer_PhoneNo">
          <mat-header-cell mat-sort-header *matHeaderCellDef
            >Customer PhoneNo</mat-header-cell
          >
          <mat-cell *matCellDef="let row">
            {{ row.Customer_PhoneNo }}
          </mat-cell>
          <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="Branch_Name">
          <mat-header-cell mat-sort-header *matHeaderCellDef
            >Branch Name</mat-header-cell
          >
          <mat-cell *matCellDef="let row">
            {{ row.Branch_Name }}
          </mat-cell>
          <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="Product_Name">
          <mat-header-cell mat-sort-header *matHeaderCellDef
            >Product Name</mat-header-cell
          >
          <mat-cell *matCellDef="let row">
            {{ row.Product_Name }}
          </mat-cell>
          <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="Total_EMI">
          <mat-header-cell mat-sort-header *matHeaderCellDef
            >Total EMI</mat-header-cell
          >
          <mat-cell *matCellDef="let row">
            {{ row.Total_EMI }}
          </mat-cell>
          <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="EMI_No">
          <mat-header-cell mat-sort-header *matHeaderCellDef
            >EMI No</mat-header-cell
          >
          <mat-cell *matCellDef="let row">{{ row.EMI_No }}</mat-cell>
          <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="Due_Date">
          <mat-header-cell mat-sort-header *matHeaderCellDef>
            Due Date
          </mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.Due_Date }}</mat-cell>
          <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="EMI_Amount">
          <mat-header-cell mat-sort-header *matHeaderCellDef
            >EMI Amount</mat-header-cell
          >
          <mat-cell *matCellDef="let row"
          style="text-align: center">
            {{ row.EMI_Amount }}
          </mat-cell>
          <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="Total_Received">
          <mat-header-cell mat-sort-header *matHeaderCellDef
            >Total Received</mat-header-cell
          >
          <mat-cell *matCellDef="let row"
          style="text-align: center">
            {{ row.Total_Received }}
          </mat-cell>
          <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="ReceivedIn_Period">
          <mat-header-cell mat-sort-header *matHeaderCellDef
            >Received InPeriod</mat-header-cell
          >
          <mat-cell *matCellDef="let row"
          style="text-align: center">
            {{ row.ReceivedIn_Period }}
          </mat-cell>
          <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="Last_PaidAmount">
          <mat-header-cell mat-sort-header *matHeaderCellDef
            >Last PaidAmount</mat-header-cell
          >
          <mat-cell *matCellDef="let row"
          style="text-align: center">
            {{ row.Last_PaidAmount }}
          </mat-cell>
          <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>


        <ng-container matColumnDef="LastPayment_Date">
          <mat-header-cell mat-sort-header *matHeaderCellDef
            >LastPayment Date</mat-header-cell
          >
          <mat-cell *matCellDef="let row"
          style="text-align: center">
            {{ row.LastPayment_Date }}
          </mat-cell>
          <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="Remaining_EMIAmount">
          <mat-header-cell mat-sort-header *matHeaderCellDef
            >Remaining EMIAmount</mat-header-cell
          >
          <mat-cell *matCellDef="let row" style="text-align: center">
            {{ row.Remaining_EMIAmount }}
          </mat-cell>
          <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="EMI_Status">
          <mat-header-cell mat-sort-header *matHeaderCellDef>
            EMI Status
          </mat-header-cell>
          <mat-cell *matCellDef="let row"
           style="text-align: center">{{ row.EMI_Status }}</mat-cell>
          <mat-footer-cell
            *matFooterCellDef
            class="text-center"
          ></mat-footer-cell>  
        </ng-container> 

        <mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
          class="sticky-footer fontcolor"
          style="background: #4dc3a3;line-height: 1.5 !important;"
        ></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: displayedColumns; let i = index"
          
        ></mat-row>
        <mat-footer-row
          class="sticky-footer fontcolor"
          *matFooterRowDef="displayedColumns; sticky: true"
          style="background: #4dc3a3"
        ></mat-footer-row>
      </mat-table>
    </div>
    <div class="row m-0 ml-3">
      <div class="col-md-4 mt-2">
        <button
          class="mt-3 btn font-size-12 button-btn"
          (click)="exportTable(exporter)"
        >
          <i
            class="fa fa-file-export mr-1"
            style="font-size: medium; cursor: pointer"
          ></i>
          Export
        </button>
      </div>
      <div class="col-md-8 mt-2">
        <mat-paginator
          #paginatorRef
          [pageSizeOptions]="[20, 50]"
          showFirstLastButtons
        ></mat-paginator>
      </div>
    </div>
  </div> 
</div>
